var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "toggle-container",
    class: { checked: _vm.isChecked },
    on: { click: _vm.onToggle },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }